import React from 'react'
import PropTypes from 'prop-types'
import Swipeable from 'react-swipeable'

export default class ShoppingCartProduct extends React.Component {

  state = { isOpened: false }

  onClick = () => { this.setState({ isOpened: !this.state.isOpened }) }

  handleLeftSwipe = (e, x) => { console.log(x); this.setState({ isOpened: true }) }
  handleRightSwipe = (e, x) => { console.log(x); this.setState({ isOpened: false }) }
  handleTap = () => { this.setState({ isOpened: !this.state.isOpened }) }

  onDeleteProduct = () => {
    this.setState({ isOpened: false })
    this.props.onDelete(this.props.productId)
  }

  render () {
    const { title, price, image, variant, enableScroll } = this.props

    let addScrollClass = () => {
      if (enableScroll) {
        return 'js-scroll'
      } else {
        return ''
      }
    }

    return (
      <div className={addScrollClass() + ' ou_cart__product __scrollable' + (this.state.isOpened ? ' ou_cart__product-controls-open' : '')}>
        <Swipeable
          onSwipedLeft={this.handleLeftSwipe}
          onSwipedRight={this.handleRightSwipe}
        >
          <div className={`ou_cart__product-content __scrollable ${addScrollClass()}`}>
            <div className={`ou_cart__product-image __scrollable ${addScrollClass()}`} style={{backgroundImage: `url(${image})`}} onClick={this.handleTap} />
            <div className={`ou_cart__product-info __scrollable ${addScrollClass()}`}>
              <div className={`ou_cart__product-title __scrollable ${addScrollClass()}`}>{title}</div>
              {variant.map((v, index, arr) => (
                <div key={index} className={addScrollClass() + ' ou_cart__product-variant __scrollable' + ((index === arr.length - 1) ? ' ou_cart__product-variant--last' : '')}>
                  <span className={`ou_cart__product-variant-title __scrollable ${addScrollClass()}`}>{v.title}:</span> {v.value}
                </div>
              ))}
              <div className={`ou_cart__product-price __scrollable ${addScrollClass()}`}>${(+price).toFixed(2)}</div>
            </div>
          </div>
        </Swipeable>
        <div className='ou_cart__product-controls __scrollable'>
          <div
            className='ou_cart__product-control ou_cart__product-control--remove __scrollable'
            onClick={this.onDeleteProduct}
          >
            <span className='ou_cart__product-control-text __scrollable'>Remove</span>
          </div>
        </div>
      </div>
    )
  }

  static propTypes = {
    title: PropTypes.string,
    price: PropTypes.string,
    image: PropTypes.string,
    variant: PropTypes.array,
    productId: PropTypes.string,
    onDelete: PropTypes.func,
    enableScroll: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/components/cart/ShoppingCartProduct.js